import { Dispatch, useEffect } from 'react';
import { AnyAction } from 'redux';
import { isHedgeLeg } from './leg-functions';
import { GreeksView } from './views/greeks';
import { State, updateHedgeLeg } from './store';

interface Props {
  readonly state: Pick<State, 'legs'>;
  readonly greeks: Pick<GreeksView, 'delta' | 'mark_price'>;
  readonly dispatch: Dispatch<AnyAction>;
}

export default function usePremiumAdjustedDeltaHedge({
  state,
  greeks,
  dispatch,
}: Props) {
  const hedgeIdx = state.legs.findIndex(isHedgeLeg);
  const hedgeLeg = hedgeIdx !== -1 ? state.legs[hedgeIdx] : undefined;

  useEffect(() => {
    if (greeks.delta === '-' || greeks.mark_price === '-') return;
    if (hedgeLeg?.price == null) return;
    dispatch(
      updateHedgeLeg({
        legIndex: hedgeIdx,
      }),
    );
  }, [hedgeLeg?.price, hedgeIdx, greeks.delta, greeks.mark_price, dispatch]);
}
